import { KTSVG } from "../../../../../_metronic/helpers";
import { HowToVideo } from "../../../../../services/cellcast.type";
import { getCategoryDisplayName, getVideoThumbnail } from "../../../../Utils/videoUtils";

type Props = {
  item: HowToVideo,
   onClick: (video: HowToVideo) => void;
}

const VideoCard: React.FC<Props> = ({
  item,
  onClick,
}) => {
  return (
    <div
      className="card border-0 card-video bg-card border rounded-lg cursor-pointer hover:shadow-lg transition-shadow group"
      onClick={() => onClick(item)}
      style={{ maxWidth: 380 }}
    >
      {/* Thumbnail */}
      <div className="position-relative">
        {item.imagePath ? (
          <img
            src={getVideoThumbnail(item)}
            alt={item.title}
            className="w-100 object-cover rounded-top"
            style={{ height: 225 }}
          />
        ) : item.videoUrl ? (
          <video
            src={getVideoThumbnail(item)}
            className="w-100 object-cover rounded-top"
            style={{ height: 225 }}
            poster={item.imagePath}
            controls={false}
            preload="metadata"
          />
        ) : (
          <img
            src={getVideoThumbnail(item)}
            alt={item.title}
            className="w-100 object-cover rounded-top"
            style={{ height: 225 }}
          />
        )}
        {/* Duration */}
        {/* {item.videoUrl && (
          <div className="position-absolute bottom-0 end-0 m-2 bg-black text-white px-2 py-1 rounded d-flex align-items-center gap-1" style={{ fontSize: 14 }}>
            <KTSVG path="/media/icons/duotune/general/gen007.svg" className="me-1" />
            <span>5:00</span>
          </div>
        )} */}
      </div>

      {/* Card Body */}
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          {/* Category badge */}
          {item.category && (
            <div className="badge badge-light-primary how-to-videos-badge">
              {getCategoryDisplayName(item.category)}
            </div>
          )}
            {/* Published date */}
        {item.updatedAt && (
          <div className="text-muted" style={{ fontSize: 13 }}>
            <strong>Published:</strong> {new Date(item.updatedAt).toLocaleDateString()}
          </div>
        )}
        </div>
        <h5 className="mb-5 fw-bold">{item.title}</h5>
        <p className="card-text text-muted mb-3" style={{ fontSize: 12 }}>{item.description}</p>
        {/* Article info */}
        {item.subTitle && (
          <div className="text-muted mb-1" style={{ fontSize: 12 }}>
            <strong>Article:</strong> {item.subTitle}
          </div>
        )}
      
      </div>
    </div>
  );
}

export default VideoCard;